import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

export const REPORT_NAME_PROMPT_KEY = "enableReportNamePrompt";

export function useIsReportNamePromptEnabled() {
  const { globalConfigMap } = useContext(AuthContext);
  return globalConfigMap?.isEnabled?.(REPORT_NAME_PROMPT_KEY, true) ?? true;
}

export default useIsReportNamePromptEnabled;
